export default __webpack_public_path__ + "static/media/Covid.a9d12ea5.png";